
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.283","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.564 22.368v-8.98a3.838 3.838 0 011.127-2.723 3.87 3.87 0 011.971-1.053c.248-.05.498-.074.751-.074h8.981a3.838 3.838 0 012.722 1.127 3.87 3.87 0 011.053 1.97c.05.25.074.5.074.752v8.981a3.838 3.838 0 01-1.127 2.722 3.87 3.87 0 01-1.97 1.053c-.249.05-.499.074-.752.074h-8.98a3.838 3.838 0 01-2.723-1.127 3.87 3.87 0 01-1.053-1.97 3.838 3.838 0 01-.074-.752zM6.15 4.727a1.588 1.588 0 01.469-1.134 1.6 1.6 0 011.134-.47h4.49a1.588 1.588 0 011.135.47 1.6 1.6 0 01.347 1.748 1.6 1.6 0 01-1.482.99h-4.49a1.588 1.588 0 01-1.134-.47 1.6 1.6 0 01-.47-1.134zM2.809 23.463a1.588 1.588 0 01-1.134-.47 1.6 1.6 0 01-.47-1.134v-4.49a1.588 1.588 0 01.47-1.134 1.6 1.6 0 011.748-.348 1.6 1.6 0 01.99 1.482v4.49a1.588 1.588 0 01-.47 1.135 1.6 1.6 0 01-1.134.47z"}}),_c('path',{attrs:{"d":"M19.62 22.688h5.677M19.62 19.48h5.677M19.62 16.273h5.677M19.62 13.066h5.677M16.093 25.896V9.86","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M7.753 5.978V22.63h4.83V5.978M4.064 21.855h3.407v-4.83H4.064","stroke-linejoin":"round"}})])])
          )
        }
      }
    